export const formatDateWithHour = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString; // Retorna o valor original se não for uma data válida
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export const formatDateWithoutHour = (dateString) => {
    if (!dateString) return '';

    // Extrair apenas a parte da data "YYYY-MM-DD"
    const datePart = dateString.split('T')[0]; // "2025-01-04"
    const [year, month, day] = datePart.split('-').map(Number);
    if (!year || !month || !day) return dateString;

    return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
};